export const useModalStore = defineStore("modal-store", {
  state: () => {
    return {
      show: false,
    };
  },
  actions: {
    showModal(): void {
      this.show = true;
    },
    hideModal(): void {
      this.show = false;
    },
  },
});
